let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("80pzY")).then(() => parcelRequire('4bIqg'));